<template>
  <div class="main_right elevator_authorize_page">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="authorize">
      <div class="elevator_box">
        <div v-for="liftDevice in liftDeviceList" :class="currentElevator === liftDevice.code ? 'elevator_item_current' : 'elevator_item'" @click="changeElevator(liftDevice.code)">
          <i class="el-icon-damai-dianti1"></i>
          <span>{{liftDevice.name}}</span>
        </div>
      </div>

      <div class="person_box">
        <div class="search-line">
          <div style="display: flex;justify-content: flex-start;align-items: center;">
            <button-add value="添加授权" @click="toAuthorizeAddPage" v-if="permissionCodes.indexOf('009003001') !== -1"/>
            <button-cancel :value="showTable==='person' ? '查看住户' : '查看人员'" @cancel="changeShowTable"/>
          </div>
          <input-search :placeholder="showTable==='person' ? '姓名/卡号' : '住户名称' " @search="search"/>
        </div>
        <table-main v-if="showTable === 'person'" :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" :operationArr="operationArr" @changeSelection="changeSelection" @changePagination="changePagination" @goToModifyPage="goToModifyPage" @deleteLine="deleteLine" />

        <table-main v-if="showTable === 'enterprise'" :selection="false" :tableHead="tableEnterpriseHead" :tableData="tableEnterpriseData" :total="total" :pageNum="pageNum" :pageSize="pageSize" :operationArr="operationArr" @changeSelection="changeSelection" @changePagination="changePagination" @goToModifyPage="goToModifyPage" @deleteLine="deleteEnterpriseLine" />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import api from "../../api/LadderControl";
import { errorHandler } from "../../../utils/errorHandler";
import TableMain from "../../../components/Table/TableMain";
import ButtonAdd from "../../../components/common/buttons/button-add";
import InputSearch from "../../../components/Input/InputSearch";
import { nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import ButtonCancel from "../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonCancel,
    InputSearch,
    ButtonAdd,
    TableMain,
    Breadcrumb
  },
  name: "elevator-authorize",
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: "智慧梯控",
            name: "ladder-device"
          },
          {
            value: "授权乘梯"
          }
        ]
      },
      addRouterName: "authorize-add",
      currentElevator: "",
      permissionCodes: "",
      total: 0,
      pageSize: 10,
      pageNum: 1,
      searchKey: "",
      liftDeviceList: [],
      operationArr: ["modify", "delete"],
      tableHead: [
        {
          prop: "personName",
          label: "人员姓名"
        },
        {
          prop: "cardNumberEntity",
          label: "卡号"
        },
        {
          prop: "enterpriseName",
          label: "住户名称"
        },
        {
          prop: "levels",
          label: "授权楼层"
        }
      ],
      tableData: [],
      tableEnterpriseHead: [
        {
          prop: "enterpriseName",
          label: "住户名称"
        },
        {
          prop: "levels",
          label: "授权楼层"
        }
      ],
      tableEnterpriseData: [],

      showTable: "person"
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getLiftDeviceList();
  },
  activated() {
    this.getLiftDeviceList();
  },
  methods: {
    // 修改展示表
    changeShowTable() {
      if (this.showTable === "person") {
        this.showTable = "enterprise";
      } else {
        this.showTable = "person";
      }
      this.pageSize = 10;
      this.pageNum = 1;
      this.searchKey = "";
      this.getLiftAuthorityPage();
    },
    // 获取电梯列表
    getLiftDeviceList() {
      api
        .getLiftDeviceList()
        .then(data => {
          this.liftDeviceList = data;
          if (data.length > 0) {
            this.currentElevator = data[0].code;
            this.getLiftAuthorityPage();
          }
        })
        .catch(errorHandler("获取电梯列表失败"));
    },
    // 获取授权人员列表
    getLiftAuthorityPage() {
      if (this.showTable === "person") {
        api
          .getLiftAuthorityPage({
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            searchKey: this.searchKey,
            liftDeviceCode: this.currentElevator
          })
          .then(data => {
            this.total = data.total;
            this.tableData = data.list;
          })
          .catch(errorHandler("获取失败"));
      } else {
        api
          .getLiftAuthorityForEnterprisePage({
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            searchKey: this.searchKey,
            liftDeviceCode: this.currentElevator
          })
          .then(data => {
            this.total = data.total;
            this.tableEnterpriseData = data.list;
          })
          .catch(errorHandler("获取失败"));
      }
    },
    // searchKey (v) {
    //   this.pageNum = 1
    //   this.requestData.searchKey = v
    //   this.getLiftAuthorityPage()
    // },
    search(v) {
      this.pageNum = 1;
      this.searchKey = v;
      this.getLiftAuthorityPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getLiftAuthorityPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    // 换电梯
    changeElevator(code) {
      this.currentElevator = code;
      this.pageNum = 1;
      this.getLiftAuthorityPage();
    },

    // 授权添加页面
    toAuthorizeAddPage() {
      this.$router.push({
        name: "authorize-add"
      });
    },

    // 修改
    goToModifyPage(code) {
      let data = {};
      if (this.showTable === "person") {
        this.tableData.map(v => {
          if (v.code === code) {
            data = v;
            data._ModifyObjectName = "person";
          }
        });
      } else {
        this.tableEnterpriseData.map(v => {
          if (v.code === code) {
            data = v;
            data._ModifyObjectName = "enterprise";
          }
        });
      }
      this.$router.push({
        path: `/authorize_modify/${JSON.stringify(data)}`,
        query: data
      });
    },

    // 删除
    deleteLine(code) {
      api
        .deleteLiftAuthorityByCodes(code)
        .then(data => {
          nSuccess("删除成功");
          this.getLiftAuthorityPage();
        })
        .catch(errorHandler("删除失败"));
    },

    // 删除住户
    deleteEnterpriseLine(code) {
      api
        .deleteLiftAuthorityForEnterpriseByCodes(code)
        .then(data => {
          nSuccess("删除成功");
          this.getLiftAuthorityPage();
        })
        .catch(errorHandler("删除失败"));
    }
  }
};
</script>

<style lang="less">
.elevator_authorize_page {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  .authorize {
    flex: 1;
    display: flex;
    justify-content: space-between;
    .elevator_box {
      width: 20%;
      height: 100%;
      border-left: 1px solid #eeeeee;
      border-right: 1px solid #eeeeee;
      .el-icon-damai-dianti1 {
        font-size: 30px;
      }
      .elevator_item {
        line-height: 60px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: flex-start;
        justify-items: center;
        padding: 0 10px;
        i {
          line-height: 60px;
        }
        &:hover {
          cursor: pointer;
          background-color: #ecf5ff;
        }
      }
      .elevator_item_current {
        line-height: 60px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: flex-start;
        justify-items: center;
        padding: 0 10px;
        color: #00a0e6;
        background-color: #ecf5ff;
        i {
          line-height: 60px;
        }
      }
    }
    .person_box {
      width: 80%;
      padding: 20px 10px;
      .search-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/Authorize/ElevatorAuthorize.vue